module.exports = __webpack_public_path__ + "img/vir1.db2c8e0a.png";